<div
    role="group"
    class="example-tel-input-container"
    [formGroup]="parts"
    [attr.aria-labelledby]="_formField?.getLabelId()"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
>
    <input 
        matInput
        formControlName="phone"
        (input)="onInputChange($event)" 
        size="14" 
        maxlength="14" 
        #phone
        placeholder="Enter phone number"
    />
</div>
